import { InjectionToken } from '@angular/core';
import { from } from 'rxjs';

export type ObservableCreator = typeof from;

export const OBSERVABLE_CREATOR = new InjectionToken<ObservableCreator>('OBSERVABLE_CREATOR');
